module.exports = __webpack_public_path__ + "static/woman-cellphone-square.61202345.jpg";